import { createSlice } from '@reduxjs/toolkit';

const kmsSlice = createSlice({
  name: 'kms',
  initialState: {
    emp: {},
    isRegisterPin: false,
    isUnRegisterPin: false,
  },
  reducers: {
    getReadEmployeeInfo: () => {},
    getReadEmployeeInfoSuccess: (state, { payload }) => {
      state.emp = payload.memberVO;
    },
    addPinPasswordKms: state => {
      state.isRegisterPin = false;
    },
    addPinPasswordKmsSuccess: (state, { payload }) => {
      state.isRegisterPin = true;
    },
    addPinPasswordKmsFail: state => {
      state.isRegisterPin = true; // imsi
      // state.isPasswordCheck = false;
    },
    removeKmsPassword: () => {},
    removeKmsPasswordSuccess: (state, { payload }) => {
      state.isUnRegisterPin = payload;
    },
  },
});

export const {
  getReadEmployeeInfo,
  getReadEmployeeInfoSuccess,
  addPinPasswordKms,
  addPinPasswordKmsSuccess,
  addPinPasswordKmsFail,
  removeKmsPassword,
  removeKmsPasswordSuccess,
} = kmsSlice.actions;
export default kmsSlice.reducer;
